<template>
  <el-card shadow="always" :body-style="{ padding: '20px', height: '72vh' }">
    <div slot="header">
      <div slot="header" class="FC">
        <img src="@/assets/home/new.png" alt="" />
        <span style="margin-left: 16px;font-weight: bold;font-size: 15px;">今日发货明细</span>
      </div>
    </div>
    <!-- card body -->
    <div class="container">
      <el-descriptions class="margin-top" style="width: 100%" :column="4" border>
        <el-descriptions-item>
          <template slot="label"> 发货总单数 </template>
          <el-input v-model="detailed.sumsingular" size="normal" type="number"></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 已发车次 </template>
          <el-input v-model="detailed.issued" size="normal" type="number"></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 在途车次 </template>
          <el-input v-model="detailed.transit" size="normal" type="number"></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <div style="width: 100%;text-align: center;">
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-descriptions-item>
        <!-- <el-descriptions-item>
          <template slot="label"> 关键词</template>
        </el-descriptions-item> -->
      </el-descriptions>
      <div style="display: flex;margin-top: 40px;">
        <div style="width: 20%;">
          <el-input placeholder="请输入关键词搜索" size="normal" style="width: 100%;" clearable v-model="seachword"
            @input="GetGoodsDetailedList()"></el-input>
        </div>
        <div style="margin-left: 10px;width: 80%;">
          <el-button type="success" @click="dialogVisibleExEmployees = true">导入</el-button>
          <el-button type="primary" @click="dialogVisible = true">添加</el-button>

          <div style="float: right;margin-right: 10px;">
            <el-button type="success" @click="exportExcel">导出</el-button>
            <el-button type="danger" @click="DelGoodsDetailedBath">批量删除</el-button>
          </div>
        </div>
      </div>
      <div class="tablesBox">
        <div class="tablesContent">
          <el-table style="margin-top: 20px;" align="center" stripe :data="tableData" v-loading="loading" height="0"
            :header-cell-style="{
              background: '#EBEFF2',
              color: '#1E2134',
              fontWeight: 'bold',
            }" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
            <el-table-column align="center" label="单号" prop="pjgd03">
            </el-table-column>
            <el-table-column align="center" label="驾驶员" prop="pjgd04">
            </el-table-column>
            <el-table-column align="center" label="车牌号" prop="pjgd05">
            </el-table-column>
            <el-table-column align="center" label="电话" prop="pjgd06">
            </el-table-column>
            <el-table-column align="center" label="方量" prop="pjgd07">
            </el-table-column>
            <el-table-column align="center" label="发货时间" width="160" prop="pjgd08">
            </el-table-column>
            <el-table-column align="center" label="到货时间" width="160" prop="pjgd09">
            </el-table-column>
            <el-table-column align="center" label="添加人" prop="pjgd10">
            </el-table-column>
            <el-table-column align="center" label="添加时间" width="160" prop="pjgd11">
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="primary" size="small" @click="updateGoodsDetailed(scope.row)">编辑</el-button>
                <el-popconfirm title="确定删除这条数据吗？" @confirm="DelGoodsDetailed(scope.row)">
                  <el-button style="margin-left: 10px;" slot="reference" type="danger" size="small">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination align="right" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="添加" :visible.sync="dialogVisible" width="75%" :before-close="handleClose">
      <el-table :header-cell-style="{
        background: '#EBEFF2',
        color: '#1E2134',
        fontWeight: 'bold',
      }" align="center" stripe :data="list">
        <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
        <el-table-column align="center" label="单号">
          <template slot-scope="scope">
            <el-input size="normal" v-model="scope.row.pjgd03" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="驾驶员">
          <template slot-scope="scope">
            <el-input size="normal" v-model="scope.row.pjgd04" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="车牌号">
          <template slot-scope="scope">
            <el-input size="normal" v-model="scope.row.pjgd05" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="电话">
          <template slot-scope="scope">
            <el-input size="normal" v-model="scope.row.pjgd06" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="方量">
          <template slot-scope="scope">
            <el-input size="normal" v-model="scope.row.pjgd07" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="发货时间" width="210">
          <template slot-scope="scope">
            <el-date-picker style="width:200px" v-model="scope.row.pjgd08" type="datetime" placeholder="选择日期时间"
              align="right" :picker-options="pickerOptions">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" label="到货时间" width="210">
          <template slot-scope="scope">
            <el-date-picker style="width:200px" v-model="scope.row.pjgd09" type="datetime" placeholder="选择日期时间"
              align="right" :picker-options="pickerOptions">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="list.push({})">+</el-button>
            <el-button type="danger" size="small" @click="list.splice(scope.$index, 1)">-</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="InsertGoodsDetailed()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="updatedialogVisible" width="35%" :before-close="handleClose">
      <div style="padding:0px 10% 0px 10%">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="单号">
            <el-input v-model="form.pjgd03"></el-input>
          </el-form-item>
          <el-form-item label="驾驶员">
            <el-input v-model="form.pjgd04"></el-input>
          </el-form-item>
          <el-form-item label="车牌号">
            <el-input v-model="form.pjgd05"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="form.pjgd06"></el-input>
          </el-form-item>
          <el-form-item label="方量">
            <el-input v-model="form.pjgd07"></el-input>
          </el-form-item>
          <el-form-item label="发货时间">
            <el-date-picker v-model="form.pjgd08" type="datetime" placeholder="选择日期时间" align="right"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到货时间">
            <el-date-picker v-model="form.pjgd09" type="datetime" placeholder="选择日期时间" align="right"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updatedialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdateGoodsDetailed()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="dialogVisibleExEmployees" width="23%">
      <p style="text-indent: 2em; padding: 0px 15px 10px 15px">
        点击下载模板表格文件：导入
        <a style="color: #035dff; cursor: pointer" :href="$store.state.baseUrl + '/UploadFiles/发货明细.xlsx'"
          target="_blank">示例表格.xls</a>
        并按要求填写好后上传。
      </p>
      <el-upload ref="upload" class="upload-demo" :action="actionUrl" :on-change="handleChange" :file-list="fileList"
        :limit="1" :data="uploadData" :before-upload="beforeUpload" accept=".xlsx" :auto-upload="false"
        :on-success="uploadSuccess" :headers="importHeaders" :on-exceed="handleExceed">
        <el-button style="margin-left: 15px" size="small" type="primary">选择文件</el-button>
        <!-- @click="importExcel" -->
        <!-- <input type="file" id="excel" style="display: none" /> -->
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpload()">确 定</el-button>
        <el-button @click="dialogVisibleExEmployees = false">取 消</el-button>
      </span>
    </el-dialog>
    <div class="exportExcel-table" v-show="false">
      <el-table :data="exportTableData">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column label="单号" prop="pjgd03"> </el-table-column>
        <el-table-column label="驾驶员" prop="pjgd04"> </el-table-column>
        <el-table-column label="车牌号" prop="pjgd05"> </el-table-column>
        <el-table-column label="电话" prop="pjgd06"> </el-table-column>
        <el-table-column label="方量" prop="pjgd07"> </el-table-column>
        <el-table-column label="发货时间" prop="pjgd08"> </el-table-column>
        <el-table-column label="到货时间" prop="pjgd09"> </el-table-column>
        <el-table-column label="添加人" prop="pjgd10"> </el-table-column>
        <el-table-column label="添加时间" prop="pjgd11"> </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import {
  insertGoods,
  GetGoods,
  GetGoodsDetailedList,
  InsertGoodsDetailed,
  DelGoodsDetailed,
  UpdateGoodsDetailed,
} from "@/setAxios";
import dayjs from "dayjs";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  name: "RunhongXUGK",
  data() {
    return {
      dialogVisible: false,
      list: [{}],
      detailed: {
        sumsingular: "",
        issued: "",
        transit: "",
      },
      UploadFileFrom: new FormData(),
      tableData: [],
      exportTableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      seachword: "",
      loading: false,
      updatedialogVisible: false,
      form: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      dialogVisibleExEmployees: false,
      actionUrl: this.$store.state.baseUrl + "/api/InsertGDByExcel",
      uploadData: {
        xid: this.$store.state.xid,
        uid: this.$store.state.uid,
      },
      importHeaders: { token: localStorage.getItem("token") },
      fileList: [],
      multipleSelection: []
    };
  },
  mounted() { },
  created() {
    this.GetGoods();
    this.GetGoodsDetailedList();
  },
  methods: {
    async GetGoods() {
      let res = await GetGoods();
      this.detailed.sumsingular = res.Data.pjgs03;
      this.detailed.issued = res.Data.pjgs04;
      this.detailed.transit = res.Data.pjgs05;
    },
    submit() {
      this.UploadFileFrom = new FormData();
      this.UploadFileFrom.append("pjgs02", Number(this.$store.state.xid));
      this.UploadFileFrom.append("pjgs03", Number(this.detailed.sumsingular));
      this.UploadFileFrom.append("pjgs04", Number(this.detailed.issued));
      this.UploadFileFrom.append("pjgs05", Number(this.detailed.transit));
      insertGoods(this.UploadFileFrom).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "保存成功!",
          });
        } else {
          this.$message({
            type: "error",
            message: "操作有误!",
          });
        }
        this.GetGoods();
      });
    },
    InsertGoodsDetailed() {
      let that = this;
      this.list.map(function (i) {
        i.pjgd02 = that.$store.state.xid;
        i.pjgd10 = that.$store.state.uid;
        i.pjgd11 = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
        return i;
      });
      InsertGoodsDetailed({ goodsdetailed: this.list }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.dialogVisible = false;
          this.GetGoodsDetailedList();
        } else {
          this.$message({
            type: "error",
            message: "操作有误!",
          });
        }
      });
    },
    DelGoodsDetailed(row) {
      DelGoodsDetailed({ id: row.pjgd01 }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        }
        this.GetGoodsDetailedList();
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    DelGoodsDetailedBath() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          type: "warning",
          message: "请勾选!",
        });
        return;
      }
      this.$confirm('此操作将删除这些数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.multipleSelection.forEach(async (e) => {
          let res = await DelGoodsDetailed({ id: e.pjgd01 })
        })
        this.$message({
          type: "success",
          message: "删除成功!",
        });
        this.GetGoodsDetailedList();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    updateGoodsDetailed(row) {
      this.updatedialogVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    submitUpdateGoodsDetailed() {
      this.UploadFileFrom = new FormData();
      this.UploadFileFrom.append("pjgd01", this.form.pjgd01);
      this.UploadFileFrom.append("pjgd02", this.$store.state.xid);
      this.UploadFileFrom.append("pjgd03", this.form.pjgd03);
      this.UploadFileFrom.append("pjgd04", this.form.pjgd04);
      this.UploadFileFrom.append("pjgd05", this.form.pjgd05);
      this.UploadFileFrom.append("pjgd06", this.form.pjgd06);
      this.UploadFileFrom.append("pjgd07", this.form.pjgd07);
      this.UploadFileFrom.append(
        "pjgd08",
        dayjs(this.form.pjgd08).format("YYYY-MM-DD HH:mm:ss")
      );
      this.UploadFileFrom.append(
        "pjgd09",
        dayjs(this.form.pjgd09).format("YYYY-MM-DD HH:mm:ss")
      );
      this.UploadFileFrom.append("pjgd10", this.$store.state.uid);
      this.UploadFileFrom.append(
        "pjgd11",
        dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      UpdateGoodsDetailed(this.UploadFileFrom).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "编辑成功!",
          });
          this.updatedialogVisible = false;
          this.GetGoodsDetailedList();
        } else {
          this.$message({
            type: "error",
            message: "操作有误!",
          });
        }
      });
    },
    //列表
    async GetGoodsDetailedList() {
      this.loading = true;
      let params = {
        seachword: this.seachword,
        xid: this.$store.state.xid,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        date: "",
      };
      let res = await GetGoodsDetailedList({ params });
      // res.Data.list.forEach((element) => {
      //   element.pjov05 = dayjs(element.pjov05).format("YYYY年MM月DD日");
      //   element.srcList = ["" + this.$store.state.baseUrl + element.pjov03];
      // });
      this.tableData = res.Data.list;
      this.total = res.Data.total;
      this.loading = false;
    },
    // 导出表格所用
    exportExcel() {
      let params = {
        seachword: this.seachword,
        xid: this.$store.state.xid,
        pageIndex: this.currentPage,
        pageSize: 999999,
        date: "",
      };
      GetGoodsDetailedList({ params }).then((res) => {
        this.exportTableData = res.Data.list;
        this.$nextTick(() => {
          // 设置当前日期
          let time = new Date();
          let year = time.getFullYear();
          let month = time.getMonth() + 1;
          let day = time.getDate();
          let name = year + "" + month + "" + day;
          // //(name)
          /* generate workbook object from table */
          //  .table要导出的是哪一个表格
          var wb = XLSX.utils.table_to_book(
            document.querySelector(".exportExcel-table")
          );
          /* get binary string as output */
          var wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array",
          });
          try {
            //  name+'.xlsx'表示导出的excel表格名字
            FileSaver.saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              name + ".xlsx"
            );
          } catch (e) {
            // if (typeof console !== "undefined") //(e, wbout);
          }
          return wbout;
        });
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetGoodsDetailedList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetGoodsDetailedList();
    },
    handleClose(done) {
      this.$confirm("确定关闭吗？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    beforeUpload(file) {
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "xlsx";
      //(suffix);
      if (!extension) {
        this.$message({
          message: "上传文件只能是 xlsx格式!",
          type: "warning",
        });
        //this.Uploadloading = true;
      }
      return extension;
    },
    uploadSuccess(data) {
      this.dialogVisibleExEmployees = false;
      if (data.Code > 0) {
        this.$message({
          type: "success",
          message: "导入成功！",
        });
        this.GetGoodsDetailedList();
        this.fileList = [];
      } else {
        this.$message({
          type: "error",
          message: data.Message,
        });
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    submitUpload() {
      if (this.fileList.length > 0) {
        this.$refs.upload.submit();
      } else {
        this.$message({
          type: "warning",
          message: "请选择文件后上传",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.tablesBox {
  flex: auto;
  overflow: hidden;

  .tablesContent {
    height: 100%;
    width: 100%;

    .el-table {
      height: 90% !important;
    }
  }
}
</style>
